var $1c40ffbbfe9f3bda$exports = {};
$1c40ffbbfe9f3bda$exports = {
  "removeButtonLabel": "Usu\u0144",
  "removeDescription": "Naci\u015Bnij Usu\u0144, aby usun\u0105\u0107 znacznik."
};
export { $1c40ffbbfe9f3bda$exports as default };